<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>
        {{ $t('common.price.singular') }} & {{ isTemplateScheduledProduct() ?
        $t('common.capacity.singular') : $t('common.quantity.singular') }}
      </v-toolbar-title>
      <v-spacer/>
      <v-btn
        v-if="allowPriceModeToggle"
        rounded
        outlined
        color="primary"
        @click="$emit('price-mode-toggle')"
      >
        <v-icon small left>remove_red_eye</v-icon>
        Advanced Pricing
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          xs="12"
          md="6"
        >
          <amount-input
            :init-amount="parseInt(product.amount, 10)"
            @change="onChangeAmount($event)"
          />
        </v-col>
        <v-col
          cols="12"
          xs="12"
          md="6"
        >
          <v-text-field
            v-model.number="model.quantity"
            :value="product.quantity"
            outlined
            dense
            :label="isTemplateScheduledProduct() ? $t('common.capacity.singular') : $t('common.quantity.singular')"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import AmountInput from "../Common/AmountInput"
import { get } from 'lodash'

export default {
  components: { AmountInput },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    allowPriceModeToggle: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    model: {
      deep: true,
      handler() {
        this.$emit('change', this.model)
      }
    }
  },
  methods: {
    isTemplateScheduledProduct() {
      return get(this.product, 'template.id') === process.env.VUE_APP_SCHEDULED_PRODUCT_TEMPLATE_ID
        || this.$route.query.template === process.env.VUE_APP_SCHEDULED_PRODUCT_TEMPLATE_ID
    },
    onChangeAmount(val) {
      this.model.amount = val
    }
  },
  data() {
    return {
      model: {
        amount: get(this.product, 'amount', 0),
        quantity: get(this.product, 'quantity', 0)
      }
    }
  }
}
</script>
